export const CycloneConstants = {
  CYCLONE_WIND_SPEED_TO_COLOR_MAPPING : {
    '<=50': {
      'fill-color': '#80ccff'
    },
    '50-62': {
      'fill-color': '#5ebaff'
    },
    '62-88': {
      'fill-color': '#00faf4'
    },
    '88-117': {
      'fill-color': '#ccffff'
    },
    '117-165': {
      'fill-color': '#ffffcc'
    },
    '165-220': {
      'fill-color': '#ffc140'
    },
    '>220': {
      'fill-color': '#ff6060'
    }
  },
  CYCLONE_CATEGORY_TO_COLOR_MAPPING : {
    L: {
      'fill-color': '#f3f3f3'
    },
    D: {
      'fill-color': '#00faf4'
    },
    DD: {
      'fill-color': '#4a86e8'
    },
    CS: {
      'fill-color': '#1c4587'
    },
    SCS: {
      'fill-color': '#fbbc04'
    },
    VSCS: {
      'fill-color': '#ff6d01'
    },
    ESCS: {
      'fill-color': '#ff0000'
    },
    SuCS: {
      'fill-color': '#990000'
    }
  },
  CYCLONE_CATEGORY_MAPPING: {
    L: 'Low pressure Area',
    D: 'Depression',
    DD: 'Deep Depression',
    CS: 'Cyclonic Storm',
    SCS: 'Severe Cyclonic Storm',
    VSCS: 'Very Severe Cyclonic Storm',
    ESCS: 'Extremely Severe Cyclonic Storm',
    SuCS: 'Super Cyclonic Storm'
  }
};
